const doc = [({"se":({"js":({"components":({"school_classes":({"layout":({"the_school_class_couldnt_be_found":"Klassen hittades ej."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;